// extracted by mini-css-extract-plugin
export default {"message":"notification_message__IbhVM"};